<template>
<span class="wrapper" :class="{'flex-end':$store.state.session.user.UserID === message.From}">
  <div class="" :class="{'messageBalloonMainReverse':$store.state.session.user.UserID === message.From,'messageBalloonMain':$store.state.session.user.UserID !== message.From}" :style="cssProps">
    <!-- <div class="spacer" v-if="$store.state.session.user.UserID === message.From" /> -->
    <div :class="{
      speechBubbleTailedLeft:
        $store.state.session.user.UserID !== message.From &&
        !message.continueFromSameBuddy,
      speechBubbleNonTailedLeft:
        $store.state.session.user.UserID !== message.From &&
        message.continueFromSameBuddy,
      speechBubbleTailedRight:
        $store.state.session.user.UserID === message.From &&
        !message.continueFromSameBuddy,
      speechBubbleNonTailedRight:
        $store.state.session.user.UserID === message.From &&
        message.continueFromSameBuddy
    }"
    >
      <div class="senderName" :style="{ color: userColor(message.From) }"
           v-if="message.isGroup === true && $store.state.session.user.UserID !== message.From && !message.continueFromSameBuddy"
      >
        {{ getUserNameDisplay(message.From) }}
      </div>
      <div class="deletedMessageTextContainer">
        {{ getDeletedMessageDisplay }}
      </div>

      <MessageBalloonInfoRow :message="message" />
    </div>

    <div class="spacer" v-if="$store.state.session.user.UserID !== message.From" />
  </div>
  </span>
</template>

<script>
import MessageBalloonInfoRow from './common/MessageBalloonInfoRow.vue'
import {
  messageMixin
} from '@/mixins/messageMixin.js'

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  mixins: [messageMixin],
  data () {
    return {
      currentVisibleChars: 1000,
      hasMoreText: false
    }
  },
  methods: {

    getMessageBody () {
      let body = this.message.Body.substring(0, this.currentVisibleChars)
      if (this.message.Body.length > body.length) {
        this.hasMoreText = true
        body = body + '...'
      } else {
        this.hasMoreText = false
      }

      return body.replace(/\n/g, '<br/>')
    }
  },
  computed: {
    cssProps () {
      return {
        '--hasMoreTextLinkColor': this.$config.theme.default.messageContainer
          .messageBalloon.hasMoreTextLinkColor,
        '--outgoingMessageBgColor': this.$config.theme.default.messageContainer
          .messageBalloon.outgoingMessageBgColor
      }
    },
    getDeletedMessageDisplay () {
      if (this.message.From === this.$store.state.session.user.UserID) {
        return 'Bu mesajı sildiniz.'
      } else {
        return 'Bu mesaj silindi.'
      }
    }
  },

  components: {
    MessageBalloonInfoRow
  }
}

</script>

<style lang="less" scoped>
  @import "../../../../../style/messageBalloon";

  .hasMoreTextLink {
    color: var(--hasMoreTextLinkColor);
    cursor: pointer;
    margin-left: 10px;
  }

  .emojiMessage {
    font-size: 40px;
    margin-left: 20px;
  }

</style>

<style>
  br {
    content: "";
    margin: 2em;
    display: block;
    font-size: 24%;
  }

  textarea {
    font-family: "Raleway";
  }
</style>
